const PENDING_SUBMISSION_KEY = 'dss360_pending_submission'

export const PENDING_SUBMISSION_TTL_MS = 24 * 60 * 60 * 1000

export function savePendingSubmission(entry) {
  try {
    localStorage.setItem(PENDING_SUBMISSION_KEY, JSON.stringify(entry))
  }
  catch {
    // localStorage unavailable (private mode/blocked): degrade gracefully
  }
}

// Reads the stored entry without consuming it: login flows can involve a
// full page navigation that kills an in-flight offer toast, so the entry
// must survive until the user acts on it. It is only discarded here when
// it belongs to another user or has expired; consumption happens at the
// moment of the resend attempt (clearPendingSubmission).
export function peekPendingSubmission({ b2cId }) {
  try {
    const raw = localStorage.getItem(PENDING_SUBMISSION_KEY)
    if (!raw)
      return null

    const entry = JSON.parse(raw)
    const isForAnotherUser = !entry?.b2cId || entry.b2cId !== b2cId
    const isExpired = !entry?.savedAt || Date.now() - entry.savedAt > PENDING_SUBMISSION_TTL_MS

    if (isForAnotherUser || isExpired) {
      localStorage.removeItem(PENDING_SUBMISSION_KEY)
      return null
    }

    return entry
  }
  catch {
    return null
  }
}

export function clearPendingSubmission() {
  try {
    localStorage.removeItem(PENDING_SUBMISSION_KEY)
  }
  catch {
    // localStorage unavailable: nothing to clear
  }
}
